import { createContext, useContext, useEffect, useReducer } from "react";
import {
  entryReducer,
  INITIAL_STATE,
  types,
} from "../../reducers/inventory/entryReducer";
import axios from "../../api/axios";
import {
  LOADED,
  LOADING,
  STATUS_EXCUTED,
  STATUS_NOT_LOADED,
} from "../../api/constant";
import {
  alertSuccess,
  alertWarning,
  showTypeErrorFetch,
} from "../../utilities/alerts.utilities";
import { useParams, useLocation } from "react-router-dom";
const EntryFormContext = createContext({});
const EntryFormProvider = ({ children }) => {
  const { entry_id } = useParams();
  const [state, dispatch] = useReducer(entryReducer, INITIAL_STATE);
  const { lookForCode, lookForProvider } = state;
  const location = useLocation();
  const pathNameEntryReload = "/inventory/entry";
  useEffect(() => {
    if (state.entry.id) {
      async function fetchData() {
        const items = await getItemsByMovementId(state.entry.id);
        const {
          business_client_id,
          business_name,
          order_number,
          quantity_references,
          business_nit,
          date_movement,
          warehouse_id,
          created_at,
          status_id,
          type,
        } = await getMovementId(state.entry.id);
        dispatch({
          type: types.CHANGE_PAYLOAD_ENTRY,
          payload: {
            ...state.entry,
            business_client_id,
            business_name,
            business_nit,
            quantity_references,
            order_number,
            warehouse_id,
            status_id,
            type,
            created_at: new Date(created_at),
            date_movement: new Date(date_movement),
            items,
          },
        });
        dispatch({
          type: types.RELOAD_OBSERTATIONS,
        });
        dispatch({
          type: types.RELOAD_DOCUMENTS,
        });
      }

      fetchData();
    }
  }, [state.entry.id]);


  useEffect(() => {
    if(location.pathname===pathNameEntryReload){
      dispatch({
        type: types.RELOAD_ENTRY_INITIAL_STATE,
      })
    }
  }, [location])
  
  useEffect(() => {
    if (
      state.entry.id &&
      state.entry.observation.status === STATUS_NOT_LOADED
    ) {
      axios()
        .get(`inventory/header_movement/${state.entry.id}/getObservations`)
        .then(({ data }) => {
          dispatch({
            type: types.OBSERVATIONS_LOADED,
            payload: data,
          });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  }, [state.entry.observation.status]);
  useEffect(() => {
    if (state.entry.id && state.entry.document.status === STATUS_NOT_LOADED) {
      axios()
        .get(`inventory/header_movement/${state.entry.id}/documents`)
        .then(({ data }) => {
          dispatch({
            type: types.DOCUMENTS_LOADED,
            payload: data,
          });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  }, [state.entry.document.status]);

  useEffect(() => {
    if (entry_id) {
      dispatch({
        type: types.SET_ENTRY_ID,
        payload: entry_id,
      });
    }
  }, [entry_id]);

  const reloadBrands = () => {
    axios()
      .get("inventory/getBrands")
      .then(({ data }) => {
        dispatch({
          type: types.CHANGE_INPUT_MODAL,
          payload: { name: "brands", value: data ?? [] },
        });
      })
      .catch((e) => showTypeErrorFetch(e));
  };

  useEffect(() => {
    reloadBrands();
  }, []);
  const getItemsByMovementId = (header_movement_id) => {
    return axios()
      .get(`inventory/getItemsByHeaderId/${header_movement_id}`)
      .then(({ data }) => {
        return data;
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };
  const getMovementId = (header_movement_id) => {
    return axios()
      .get(`inventory/getMovementById/${header_movement_id}`)
      .then(({ data }) => {
        return data;
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };
  const lookForItemByCode = (code) => {
    dispatch({ type: types.CHANGE_STATUS_LOOK_FOR_CODE, payload: LOADING });
    axios()
      .post(`inventory/getItemByLikeCode`,{code_name:code})
      .then(({ data }) => {
        dispatch({ type: types.ITEMS_FOUND, payload: data });
      })
      .catch((e) => {
        dispatch({
          type: types.CHANGE_STATUS_LOOK_FOR_CODE,
          payload: STATUS_NOT_LOADED,
        });
        showTypeErrorFetch(e);
      });
  };
  const lookForProviderCode = (code) => {
    dispatch({ type: types.CHANGE_STATUS_LOOK_FOR_PROVIDER, payload: LOADING });
    axios()
      .get(`inventory/getProviderByLikeCode/${code}`)
      .then(({ data }) => {
        dispatch({ type: types.PROVIDERS_FOUND, payload: data });
      })
      .catch((e) => {
        dispatch({
          type: types.CHANGE_STATUS_LOOK_FOR_CODE,
          payload: STATUS_NOT_LOADED,
        });
        showTypeErrorFetch(e);
      });
  };
  useEffect(() => {
    if (lookForProvider.length > 4) {
      lookForProviderCode(lookForProvider);
    } else {
      dispatch({ type: types.PROVIDERS_FOUND, payload: [] });
    }
  }, [lookForProvider]);
  useEffect(() => {
    if (lookForCode.length > 4) {
      lookForItemByCode(lookForCode);
    } else {
      dispatch({ type: types.ITEMS_FOUND, payload: [] });
    }
  }, [lookForCode]);
  const createEntry = () => {
    dispatch({
      type: types.CHANGE_INPUT_ENTRY,
      payload: { name: "status", value: LOADING },
    });
    axios()
      .post(`inventory/createEntry`, {
        quantity_references: state.entry.quantity_references,
        date_movement: state.entry.date_movement,
        order_number: state.entry.order_number,
        business_client_id: state.entry.business_client_id,
        warehouse_id: state.entry.warehouse_id,
        type: state.entry.type,
      })
      .then(({ data }) => {
        dispatch({
          type: types.CHANGE_INPUT_ENTRY_BY_OBJECT,
          payload: { id: data.id, status: LOADED },
        });
      })
      .catch((e) => {
        dispatch({
          type: types.CHANGE_INPUT_ENTRY,
          payload: { name: "status", value: STATUS_NOT_LOADED },
        });
        showTypeErrorFetch(e);
      });
  };
  const addItemModal = () => {
    if (state.modalItem.quantity < 1) {
      alertWarning("La cantidad no puede ser menor o igual a cero");
      return false;
    }
    dispatch({
      type: types.ADD_ITEM_MODAL,
    });
  };
  const saveItems = async () => {
    axios()
      .post(`inventory/saveItems/${state.entry.id}`, {
        items: state.modalItem.items,
        item_id: state.modalItem.item_id,
        warehouse_id: state.entry.warehouse_id,
      })
      .then(async ({ data }) => {
        const items = await getItemsByMovementId(state.entry.id);
        alertSuccess("Añadido");
        dispatch({
          type: types.CHANGE_PAYLOAD_ENTRY,
          payload: {
            ...state.entry,
            items,
          },
        });
        //clean fields modal
        dispatch({
          type: types.CHANGE_PAYLOAD_MODAL_ITEM,
          payload: {
            ...state.modalItem,
            items: [],
            lote: "",
            date_made: null,
            date_expired: null,
            quantity: 0,
            item_id: null,
          },
        });
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };

  const addObservation = () => {
    if (state.entry.id) {
      axios()
        .post(`inventory/header_movement/${state.entry.id}/notificated`, {
          note: state.entry.observation.text,
        })
        .then(({ data }) => {
          dispatch({
            type: types.CHANGE_INPUT_OBSERVATION,
            payload: { name: "text", value: "" },
          });
          dispatch({ type: types.RELOAD_OBSERTATIONS });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  };
  const addDocumentsToEntry = async (pictures) => {
    for await (const document of pictures) {
      var formData = new FormData();
      formData.append("document", document);
      await axios()
        .post(
          `inventory/header_movement/${state.entry.id}/documented`,
          formData
        )
        .then(({ data }) => {
          return data;
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
    dispatch({ type: types.RELOAD_DOCUMENTS });
  };
  const finishEntry = () => {
    axios()
      .post(`inventory/header_movement/${state.entry.id}/finish`, {})
      .then(({ data }) => {
          dispatch({
            type: types.CHANGE_PAYLOAD_ENTRY,
            payload: {
              ...state.entry,
              status_id: STATUS_EXCUTED,
              created_at: new Date(),
            },
          }); 
        return data;
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
      
  };
  const deleteDetail = (detail_id) => {
    dispatch({ type: types.DELETE_ENTRY_DETAIL, payload: detail_id });
    axios()
      .delete(`inventory/header_movement_detail/${detail_id}/delete`)
      .then(({ data }) => {
        return data;
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };
  return (
    <EntryFormContext.Provider
      value={[
        state,
        dispatch,
        {
          createEntry,
          addItemModal,
          saveItems,
          addObservation,
          addDocumentsToEntry,
          finishEntry,
          deleteDetail,
          reloadBrands,
        },
      ]}
    >
      {children}
    </EntryFormContext.Provider>
  );
};
const useEntry = () => useContext(EntryFormContext)[0];
const useDispatchEntryForm = () => useContext(EntryFormContext)[1];
const useActionsEntry = () => useContext(EntryFormContext)[2];

export { EntryFormContext, useEntry, useDispatchEntryForm, useActionsEntry };
export default EntryFormProvider;
